import { RecordPage } from './RecordPage';
export default RecordPage;
